import type { FAMOnboarding } from '../../models/membership/famOnboarding';
import { requests } from '../httpClient';

export const FamTransfer = {
    getFamTransferDetailsAsync: () => requests.get(`FamTransfer`),
    getFamTransferCanPayStatusCodesAsync: () => requests.get(`FamTransfer/CanPayStatusCodes`),
    saveTransferInformationAsync: (data: FAMOnboarding) => requests.post(`FamTransfer`, data),
    updateFamTransferDetailsAsync: (data: FAMOnboarding) => requests.put(`FamTransfer`, data),
    saveDocumentAsync: (data: FormData) => requests.post(`FamTransfer/Document`, data, {
        headers: {
            "content-type": "multipart/form-data"
        },
    }),
    submitFamTransferDetailsAsync: (famExamId: string) => requests.put(`FamTransfer/Submit`, { FamExamId: famExamId }),
    getFamTransferDocumentsAsync: () => requests.get(`FamTransfer/Documents`),
    downloadFileAsync: (name: string) => requests.getConfig<Blob>(`FamTransfer/Document/${name}`, {
        responseType: 'blob',
    }),
    deleteFileAsync: (fileType: string) => requests.delete(`FamTransfer/Document?FileType=${fileType}`),
    basketAsync: () => requests.post(`FamTransfer/Basket`, {})
};
